// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__1ePUd","info__title":"style_info__title__YVtTe","info__text":"style_info__text__3F2OV"};